import Vue from 'vue';
import Vuex from 'vuex';

import modAuth from './modules/auth';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth: modAuth,
  },
});
